import { useMutation } from "react-query"
import customAxios from "../../utils/customAxios"
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil"
import { useCookies } from "react-cookie"
import { QuizResponseType } from "../../types"
import {
  quizItemsState,
  quizResponseListState,
} from "../../recoil/QuizPage/atoms"
import useHttpErrorHandler from "../useHttpErrorHandler"
import useQuizApiErrorHandler from "../useQuizApiErrorHandler"

const axios = customAxios()

interface QuizWrapupPayloadType {
  meta: {
    user_name: string
    session_id: string
    round: number
  }
  response: QuizResponseType[]
}

const fetchQuizWrapup = (payload: QuizWrapupPayloadType) => {
  return axios.post(`/acadquiz/wrapup`, payload)
}

export const useQuizWrapup = () => {
  const quizResponseList = useRecoilValue(quizResponseListState)
  const [cookie, setCookie] = useCookies(["quizSessionId", "quizRound"])
  const setQuizItems = useSetRecoilState(quizItemsState)
  const resetQuizResponseList = useResetRecoilState(quizResponseListState)
  const { quizApiErrorHandler } = useQuizApiErrorHandler()
  const { httpErrorHandler } = useHttpErrorHandler(quizApiErrorHandler)

  const payload: QuizWrapupPayloadType = {
    meta: {
      user_name: "pizzauniv11@gmail.com",
      session_id: cookie.quizSessionId,
      round: cookie.quizRound,
    },
    response: quizResponseList,
  }

  return useMutation(() => fetchQuizWrapup(payload), {
    onSuccess: (response: any) => {
      if (response.data.round_quiz) {
        resetQuizResponseList()
        setQuizItems(response.data.round_quiz)
        setCookie("quizRound", cookie.quizRound + 1)
      }
      return response.data
    },
    onError: httpErrorHandler,
  })
}
